var $ = require('jquery');

window.jQuery = $;
window.$ = $;
import 'webpack-jquery-ui';
import 'webpack-jquery-ui/css';

require('nette.ajax.js');
require('nette.ajax.js/extensions/spinner.ajax');
require('nette.ajax.js/extensions/confirm.ajax');
require('@fancyapps/fancybox');
require('@fancyapps/fancybox/src/css/core.css');
require('@fancyapps/fancybox/src/css/slideshow.css');
import Dialog from '@anything-studio/dialog';
import "../css/admin/libs/icomoon.css";
import {initMasonry} from "./custom/masonry";
import 'sebasrodriguez-flexslider';

import AnyCookieConsent from "@anything-studio/any-cookie-consent"

var Nette = require('nette-forms');

Nette.initOnLoad();
AnyCookieConsent.init({btnColor: "#1a1a1a"});

document.addEventListener('DOMContentLoaded', function () {
})
$(function () {
	initMasonry();
	$('.hide-on-load').removeClass('hide-on-load');
	var cx = '004952301883573538763:6pbttywnthy';
	var gcse = document.createElement('script');
	gcse.type = 'text/javascript';
	gcse.async = true;
	gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(gcse, s);
	$.nette.init();
	$.nette.ext('spinner');
	$.nette.ext('confirm');

	$('.flexslider').flexslider({
		animation         : "slide",
		controlsContainer : $(".custom-controls-container"),
		customDirectionNav: $(".custom-navigation a")
	});

	$(".ico-search").click(function () {
		$(".gsc-control-searchbox-only").slideToggle();
		$(".gsc-control-searchbox-only input[type=text]").focus();
	});

});

$.nette.ext('webcontent', {
	load: function () {
		Dialog.init();
		$(".fancybox").fancybox({
			openEffect : 'elastic',
			closeEffect: 'elastic',
			helpers    : {
				title: {
					type: 'inside'
				}
			}
		});
	}
});



// WEBPACK FOOTER //
// ./js/front.nette.config.js